export default {"src":"/_next/static/media/bcd.ea5249ba.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};